export const anyPrefixRegex = /^ANY/;

export const blockName = 'search-form';
